import { render, staticRenderFns } from "./Lotto.vue?vue&type=template&id=7c5e2ae2&scoped=true"
import script from "./Lotto.vue?vue&type=script&lang=ts"
export * from "./Lotto.vue?vue&type=script&lang=ts"
import style0 from "./Lotto.vue?vue&type=style&index=0&id=7c5e2ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e2ae2",
  null
  
)

export default component.exports